// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605071007/js/" + chunkId + "." + {"44":"6a8f38b1","225":"26a21bef","481":"6df062af","486":"97196ff2","770":"d170e46d"}[chunkId] + ".0.24203164477174122.chunk.js";
};